import ApiEndpointConstants, {
  BASE_URL,
} from "../constants/ApiEndpointConstants";
import api from "./API";
import LocalStorageUtil from "../utils/LocalStorageUtil";

export const postMessage = (text, groupid) => {
  const formatText = `${text} : ad=${LocalStorageUtil.loadAdParams()},user=${LocalStorageUtil.loadAnonymousUserId()},url=${BASE_URL}`;
  return api.post(`${ApiEndpointConstants.POST_MESSAGE}`, {
    text: formatText,
    groupid,
  });
};
